import type { ImgHTMLAttributes } from 'react'

type MarkdownImageProps = Pick<
  ImgHTMLAttributes<HTMLImageElement>,
  'loading' | 'decoding'
>

export const getMarkdownImageProps = (
  props: MarkdownImageProps
): MarkdownImageProps => ({
  loading: props.loading || 'lazy',
  decoding: props.decoding || 'async'
})
